import { useCallback } from 'react';
import { useIncidentsListQuery } from '@/modules/common/queries/incidents.ts';
import { SelectPaginate, SelectPaginateOption } from 'ui';
import { IncidentResultStatus, IncidentResultWithIncidentTypeRelResponse } from 'compliance-api';

export interface EventItemOption extends IncidentResultWithIncidentTypeRelResponse {
  toString: () => string;
}

type baseProps = {
  label: string;
  formFieldTitle?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  filterByStatus?: IncidentResultStatus;
};

type singleProps = {
  isMulti: false;
  onChange: (options: SelectPaginateOption<EventItemOption>, title: string) => void;
  defaultValue?: SelectPaginateOption<{ id: number }>;
};

type multiProps = {
  isMulti: true;
  onChange: (options: SelectPaginateOption<EventItemOption>[], title: string) => void;
  defaultValue?: SelectPaginateOption<{ id: number }>[];
};

type IncidentTypeSelectPaginateProps = baseProps & (singleProps | multiProps);

const IncidentsSelectPaginate = ({
  label,
  error,
  isMulti,
  disabled,
  filterByStatus,
  formFieldTitle,
  onChange,
  defaultValue,
}: IncidentTypeSelectPaginateProps) => {
  const { fetchNextPage } = useIncidentsListQuery({
    page: 1,
    page_size: 15,
    filter_by_name: '',
    filter_by_status: filterByStatus,
  });

  const handleAsyncLoadOptions = useCallback(
    async (page: number, search?: string) => {
      const incidentsData = await fetchNextPage({ pageParam: { page, search } });
      const incidents = incidentsData?.data?.pages?.at(-1)?.data || [];
      return incidents.map(item => ({
        label: item.name,
        value: { ...item, toString: () => String(item.id) },
      }));
    },
    [fetchNextPage],
  );
  return (
    <SelectPaginate
      isClearable
      isMulti={isMulti}
      disabled={disabled}
      onAsync={handleAsyncLoadOptions}
      label={label}
      placeholder="Event..."
      error={error}
      defaultValue={defaultValue}
      onChange={options => onChange(options as any, formFieldTitle || '')}
    />
  );
};

export default IncidentsSelectPaginate;
